<template>
    <div class="modal-conainer">
        <div @click="$emit('close')"
            class="back-link">
            <svg class="icon"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1">
            <path d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                    id="path-1">
            </path>
            </svg>
            <p>Back to DID</p>
        </div>
        <div class="wrapper">
            <div class="header">
                <div>Number</div>
                <div>Type</div>
                <div>Location</div>
                <div>Price</div>
            </div>
            <div class="header-content">
                <div>{{ did.number }}</div>
                <div>{{ did.type }}</div>
                <div>{{ did.location }}</div>
                <div class="price"><span v-if="did.price">$</span>{{ did.price }}</div>
            </div>
        </div>
        <div>
            <div class="primary-button">
                <primary-button @click.native="assignDid">Confirm</primary-button>          
            </div>
        </div>
    </div>
</template>

<script>
export default {
  components: {
    PrimaryButton: () => import('@/components/Buttons/PrimaryButton.vue'),
  },
  props: ['did'],
  methods: {
    assignDid() {
      console.log("buyy")
        if(this.did) {
            // let companyId = this.$store.getters.getUser.company_uuid;

            // this.$store
            // .dispatch("AssignDid", {
            //   did: this.did.number,
            //   companyId: { company_uuid: companyId }
            // })
            // .then(() => {
            //   this.$success("Did have beed assigned.");
            
            //   this.$emit('close');
            //   this.$router.push({ name: "company-admin-dids-all-dids" });
            // })
            // .catch(err => {
            //   this.$error(err);
            // });

            this.$store.dispatch("buyDid", {  items: [ { number: this.did.number } ] })
              .then(res => {
                this.$emit('close');
                this.$router.push({ name: "company-admin-dids" });
              })
              .catch(err => this.$error(err));
        }
    }
  },
}
</script>

<style lang="scss" scoped>
  .modal-conainer {
    padding: 16px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .primary-button {
        height: 40px;
        width: 110px;
    }
    .wrapper{
        //width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .header {
            width: 220px;
            padding: 22px 0 19px 15px;
            color: #212b36;
            font-family: Helvetica Neue;
            font-size: 14px;
            font-weight: 600;
            line-height: 35px;
        }
        .header-content {
            width: 500px;
            padding: 22px 0 19px 15px;
            color: #212b36;
            font-family: Helvetica Neue;
            font-size: 14px;
            line-height: 35px;
            div {
                height: 35px;
            }
            .price {
                height: 25px;
                color: #55616e;
                font-family: Helvetica Neue;
                font-size: 14px;
                line-height: 25px;
            }
        }
    }
  }
</style>